<template>

  <div>

    <div class="content">

      <!--- TEAM NAME -->
      <div class="team-name">

        <h2>Team Name</h2>

        <!-- Edit Team Name for Admins -->
        <template v-if="is_admin">
        <a-tooltip title="Please enter a team name first" :visible="show_team_name_error && team_name === ''">
          <input
          v-model="edited_team_name"
          :placeholder="team_name || 'Please enter a team name'" maxlength="100" type="text">
        </a-tooltip>
        <!--- Save Edits button -->
        <p
        @click="saveTeamName()"
        v-if="edited_team_name && edited_team_name !== team_name"
        class="save-team-name-btn">Save Edits</p>
        </template>

        <!-- Static Team Name for Members -->
        <h3 v-else>{{ team_name }}</h3>

      </div>



      <!--- TEAM MEMBERS -->
      <div class="members">

        <h2>👯 {{ members.length }} Team Members</h2>

        <div v-for="(member, member_index) in members" class="row">

          <!-- Teammate -->
          <div class="member-container">

            <!-- Profile Pic, Name, Email -->
            <img :src="member.profile_pic || 'https://api-outsidevoice.vercel.app/public/default-profile.svg'" />
            <p class="member-name" :title="member.name">{{ member.name }}</p>
            <p class="member-email" :title="member.email">{{ member.email }} {{ isSelf(member.uid) ? '(You)' : ''}}</p>

            <!-- Role -->
            <a-dropdown v-if="is_admin && member.role !== 'invited' && (!(isSelf(member.uid) && !is_more_than_one_admin))" class="role-dropdown">
              <a class="ant-dropdown-link" @click.prevent>
                {{ _.capitalize(member.role) }} <a-icon type="down" />
              </a>
              <a-menu slot="overlay" class="dropdown">
                <a-menu-item @click="setRole(member_index, 'member')">
                  <a @click.prevent>Member</a>
                </a-menu-item>
                <a-menu-item @click="setRole(member_index, 'admin')">
                  <a @click.prevent>Admin</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <p v-else class="static-role">{{ _.capitalize(member.role) }}</p>

          </div>

          <!-- Remove Teammate -->
          <a-popconfirm
            :title="member.role === 'invited' ? 'Remove invite?' : 'Remove this team member?'"
            ok-text="Remove"
            cancel-text="Cancel"
            @confirm="removeMember(member_index)"
          >
            <!-- <a-icon v-if="(!is_admin && isSelf(member.uid)) || (is_admin && (!(isSelf(member.uid) && !is_more_than_one_admin)))" class="remove-btn" type="delete" theme="filled"/> -->
            <a-icon v-if="is_admin && !isSelf(member.uid)" class="remove-btn" type="delete" theme="filled"/>
          </a-popconfirm>

        </div>

        <center v-if="members.length === 0">
          <a-spin>
            <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
          </a-spin>
        </center>

      </div>



      <!--- INVITE -->
      <div class="invite" v-if="is_admin">

        <h2>✉️ Invite</h2>

        <div class="row" v-if="members.length < team_size_limit">

          <div class="invite-container">

            <!-- Invite Email Input -->
            <a-tooltip title="Please enter a valid email to invite" :visible="show_invite_error && invite.email !== ''">
              <input
              v-model="invite.email"
              placeholder="teammate@yourwebsite.com" maxlength="150" type="email">
            </a-tooltip>

            <!-- Select Role of Invited Member -->
            <a-dropdown class="role-dropdown">
              <a class="ant-dropdown-link" @click.prevent>
                {{ _.capitalize(invite.role) }} <a-icon type="down" />
              </a>
              <a-menu slot="overlay" class="dropdown">
                <a-menu-item @click="invite.role = 'member'">
                  <a @click.prevent>Member</a>
                </a-menu-item>
                <a-menu-item @click="invite.role = 'admin'">
                  <a @click.prevent>Admin</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>

          <!-- Invite Button -->
          <button @click="inviteMember()" class="invite-member-btn">Invite</button>

        </div>

        <div v-else>
          <p class="upgrade">Seems like you reached your team size limit. Still need more? <span @click="setupDemo">Setup a Demo Call</span></p>
        </div>

      </div>

    </div>

  </div>


</template>

<script>

export default {

  name: 'Team',

  data: function () {

    return {
      edited_team_name: _.clone(this.$store.state.account.name),
      invite: {
        email: '',
        role: 'member'
      },
      show_team_name_error: false,
      show_invite_error: false
    }

  },

  computed: {

    is_admin() {
      return this.$store.state.user.role === 'admin';
    },

    team_name() {
      return this.$store.state.account.name;
    },

    members() {
      return this.$store.state.team_members;
    },

    team_size_limit() {
      return 10;
    },

    is_more_than_one_admin() {
      let admins = _.filter(this.members, ['role', 'admin'])
      return (admins.length > 1);
    },

  },

  components: {},

  methods: {

    saveTeamName: function() {
      this.$store.dispatch('updateTeamName', this.edited_team_name);
      this.$message.success(`Team Name changed to ${this.team_name}`, 3); // Show error message for 3 seconds
    },

    setRole: function(member_index, role) {

      let member = this.members[member_index];

      // Confirm a user demoting themselves from admin to member.
      if (this.isSelf(member.uid)) {
        var result = confirm("Are you sure you want to change yourself to a member? This cannnot be undone by you.");
        if (!result) { return };
      };

      // Success message
      this.$notification.open({
        message: `${member.name || member.email}'s role changed to ${_.capitalize(role)}`,
        description: `Successfully changed role`,
        placement: 'bottomRight'
      });

      // Update role in store
      this.$store.dispatch('updateTeamMemberRole', { member_uid: member.uid, role });

    },

    removeMember: function(member_index) {

      // Remove member from list of members
      let member = this.members[member_index];

      // Success message depending on removing teammate or cancelling invite
      let notification_message = `${member.name} removed.`;
      let notification_description = `You've successfully removed ${member.name} removed from ${this.team_name || 'your team'}`;
      if (member.role === 'invited') {
        notification_message = `Cancelled invite for ${member.email}`;
        notification_description = `You've successfully cancelled this invite.`;
      };
      this.$notification.open({
        message: notification_message,
        description: notification_description,
        placement: 'bottomRight'
      });

      // Remove team member or cancel invite
      if (member.role === 'invited' && member.invite_id) {
        this.$store.dispatch('cancelTeamMemberInvite', member.invite_id);
      } else {
        this.$store.dispatch('removeTeamMember', { member_index, member });
      };

    },

    inviteMember: function() {

      if (!this.team_name) {
        this.show_team_name_error = true;
        return;
      };

      let invited_email = this.invite.email;
      let invited_role = this.invite.role;

      if (isValidEmail(invited_email) && invited_email !== this.$store.state.user.email) {

        this.show_invite_error = false;

        // Show success notification
        this.$notification.open({
          message: 'Invite Sent',
          description: `You've invited ${invited_email} to join your team.`,
          placement: 'bottomRight'
        });

        this.$store.dispatch('inviteTeamMember', this.invite);
        analytics.track('Teammate Invited');

        // Reset invite input
        this.invite = {
          email: '',
          role: 'member'
        };

      } else {
        this.show_invite_error = true;
      };

      function isValidEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      };
    },

    isSelf(member_uid) {
      return this.$store.state.user.uid === member_uid;
    },

    setupDemo() {
      Calendly.initPopupWidget({url: 'https://calendly.com/outside-voice/intro'})
    }

  },

  created() {
    analytics.page('Team');
  }
}
</script>

<style scoped lang="scss">

h2{
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 35px;
}

p{
  color: #0D303F;
  font-size: 14px;
  font-weight: 500;
}

input{
  height: 44px;
  color: #0D303F;
  padding-left: 12px;
  padding-right: 12px;
  background-color: rgb(246,246,246);
  border: 1px solid rgb(227,228,229);
  border-radius: 4px;
  text-align: left;
  &:focus{
    outline: none;
  }
}


.invite{
  .row{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .invite-container{
      width: 80%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid rgb(230,230,230);
      border-radius: 6px;
      padding-right: 20px;
      input{
        width: 82%;
        border-radius: 6px 0px 0px 6px;
      }
      .role-dropdown{
        margin-left: 15px;
        color: #0D303F;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }
    }
    .invite-member-btn{
      padding: 10px 30px;
      border-radius: 4px;
      color: black;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: .5px;
      border: 2px solid rgb(220,220,220);
      outline: none;
      opacity: .75;
      transition: all 0.2s ease;
      cursor: pointer;
      &:hover{
        border-color: rgb(150,150,150);
        opacity: 1;
      }
      &:active, &:focus{
        outline: none;
      }
    }
  }
  p.upgrade{
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    span{
      font-weight: 700;
      transition: all 0.15s ease;
      opacity: .85;
      cursor: pointer;
      &:hover{
        opacity: 1;
      }
    }
  }
}


.members{
  .row{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    .member-container{
      width: 95%;
      padding: 6px 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border: 1px solid rgb(230,230,230);
      border-radius: 6px;
      img{
        height: 40px;
        width: 40px;
        margin-right: 6px;
        border-radius: 4px;
        object-fit: cover;
      }
      p{
        margin-bottom: 0px;
        margin-left: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .member-name{
        width: 160px;
        border-right: 1px solid rgb(240,240,240);
      }
      .member-email{
        width: 280px;
      }
      .role-dropdown,
      .static-role{
        flex-grow: 1;
        text-align: right;
        padding-right: 18px;
      }
      .role-dropdown{
        color: #0D303F;
        //margin-left: 10px;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .remove-btn{
      opacity: .3;
      transition: all 0.2s ease;
      cursor: pointer;
      &:hover{
        opacity: 8;
      }
    }
  }
}

.team-name{
  display: flex;
  flex-direction: column;
  align-items: center;
  h2{
    margin-bottom: 20px;
  }
  input{
    width: 350px;
    border-radius: 4px;
    text-align: center;
  }
  .save-team-name-btn{
    margin-top: 20px;
    margin-bottom: 0px;
    color: #17C890;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover{
      color: #0E9A70;
    }
  }
  h3{
    font-size: 22px;
    font-weight: 600;
    text-align: center;
  }
}

.content > div{
  padding: 40px 8% 40px 8%;
  border-bottom: 1px solid rgb(220,220,220);
}




@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.team-name{
  input{
    width: 100%;
  }
}

.member-container{
  p:last-of-type{
    display: none;
  }
  .member-name{
    width: 48% !important;
  }
  .role-dropdown,
  .static-role{
    padding-right: 8px !important;
  }
  .remove-btn{
    transform: translateX(10px);
  }
}

.invite{
  .row{
    flex-direction: column;
    .invite-container{
      width: 100%;
      input{
        width: 65%;
      }
    }
    .role-dropdown,
    .static-role{
      flex-grow: 1;
      text-align: right;
      padding-right: 5px;
      padding-left: 5px;
      margin-left: 2px !important;
    }
    button{
      margin-top: 15px;
      width: 100%;
      border: 1px solid black !important;
      background-color: white;
      opacity: 1;
    }
  }
}
}


// Ipad Portrait
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .member-container{
    .role-dropdown,
    .static-role{
      width: 25% !important;
    }
    .remove-btn{
      transform: translateX(10px);
    }
  }

  .invite{
    .row{
      .invite-container{
        width: 100%;
      }
      .role-dropdown,
      .static-role{
        width: 25% !important;
      }
      button{
        border: 1px solid black !important;
        background-color: white;
        opacity: 1;
        margin-left: 15px;
      }
    }
  }
}



</style>
